import React, { useEffect, useRef, useState } from "react";
import Layouts from "../ant-design/templates/domesticCheckout/Layouts";
import MobileLayout from "../ant-design/templates/domesticCheckout/mobileLayout/MobileLayout";
import { useDispatch, useSelector } from "react-redux";
import {
  collpaseAddressComponent,
  handleIsShippingAddressDisplay,
  paymentSession,
  getRetryPolicyRemaining,
  resetErrorMsg,
  selectTemplate,
  setIsSessionInvalid,
  setIsSessionPaid,
  updateBrowserCountry,
  setTokenType
} from "../slices/PaymentSessionDetailsSlice";
import {
  clearPnsFromUrl,
  deleteCookie,
  generateDynamicStyling,
  getQueryParams,
  getSessionLocaleLanguage,
  getStorage,
  isEmpty,
  syncShopperRefStorage,
  PAYMENT_COMPLETION_PATHS,
  updateStorage,
} from "../Utils/utils";
import {
  selectIsMobileLayout,
} from "../slices/MobileLayoutSlice";
import Navbar from "../ant-design/resuableComponents/navBar/Navbar";
import PaymentSuccess from "../ant-design/components/paymentSuccess/PaymentSuccess";
import { Route, Routes, useNavigate } from "react-router-dom";
import {
  handleContactNumberField,
  handleEmailAddress,
  handleExpiryTime,
  handleFullNameField,
  handleMerchantLogo,
  handleOrderItem,
  handleTotalPaymentSummaryField,
  handlePanField,
  handleDobField,
  handleCustomFields,
  handleTotalPaymentSummaryValue
} from "../slices/HandleAdditionalComponentsSlice";
import { RETRY_LIMIT_KEYS, resetPaymentInitiation, retryPayment, showFailedModal, showRetryLimitReached, showRetryModal } from "../slices/PaymentInitiationSlice";
import { getPaymentInstrumentIssuers } from "../slices/PaymentInstrumentIssuersSlice";
import Loading from "../ant-design/components/loadingScreen/Loading";
import PaymentCompletionHandler from "../ant-design/components/paymentCompletionHandler/PaymentCompletionHandler";
import { PaymentProvider } from "../context/payment.context";
import timeZoneToCountry from "../staticData/timeZoneToCountry";
import { CountryData } from "../staticData/countryData";
import { syncShopperLogin } from "../slices/ShopperInfoSlice";
import { enableLocalisation, setSelectedLanguage } from "../slices/CommonPersistedSlice";
import i18n from "../Utils/i18n";
import { resetTransactionStatus, selectTransactionData } from "../slices/TransactionIdSlice";
import { intentAppName, resetUpiStatus } from "../slices/UpiSlice";
import ErrorModal from "../ant-design/components/modals/errorModal/ErrorModal";
import AvailablePaymentMethods, { getAvailablePaymentMethods } from "../ant-design/components/modals/errorModal/AvailablePaymentMethods";
import { InfoCircleOutlined } from "@ant-design/icons";
import { LockOutlined } from "@ant-design/icons";

import { useTranslation } from "react-i18next";
import TranslateText from "../ant-design/resuableComponents/TranslateText";
import { resetFinalStatusResponse } from "../slices/finalStatusSlice";
import { evaluateSurcharge, setActiveSurchargeDetail, setTotalSurchargeAmount } from "../slices/SurchargeSlice";
import { setUpiType } from "../slices/UpiSlice";
import { changeActivePaymentMethod, requestPaymentMethod, selectActivePaymentMethod } from "../slices/PaymentButtonSlice";
import { removeSelectedIntruments } from "../slices/SavedInstrumentSlice";
import { resetCardFormDetails } from "../slices/CardSlice";
import { resetCardBinData } from "../slices/BinSlice";
import PspCheckoutHandler from "../ant-design/components/pspCheckoutHandler/PspCheckoutHandler";
import PaymentNotify from "../ant-design/components/PaymentNotify/PaymentNotify";
import FppThreeDSPayment from "../ant-design/components/fppPage/FppThreeDSPayment";
import RetryModal from "../ant-design/components/modals/retryModal/RetryModal";
import AirWalllex from "../ant-design/components/airwallex/AirWalllex";
import AutoRefundLoader from "../ant-design/components/autoRefundLoader/AutoRefundLoader";
import {
  autoRetryModalClosedEvent,
  checkoutLoadedAnalytics,
  checkoutLoadedWithErrorAnalytics,
  retryButtonClickedEvent,
  retryModalClosedEvent,
  stopAutoRetryClickedEvent,
} from "../Utils/uiAnalytics";

const NON_CHECKOUT_PATHS = [
  "/payment-completion-handler",
  "/payment-notify",
  "/airwallex/3ds",
  "/fpp/3ds",
  "/psp-checkout-handler",
];

const getUpiFamily = (method) => {
  const m = (method || "").toLowerCase();
  if (!m.startsWith("upi")) return null;
  return (m.includes("otm") || m.includes("onetimemandate"))
    ? "UpiOneTimeMandate"
    : "Upi";
};

const BoxPayCheckout = () => {
  const isMobileLayout = useSelector((state) => selectIsMobileLayout(state));
  const [token, setToken] = useState(null);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isIframe = window.self !== window.top;
  const sessionDetails = useSelector((state) => state.paymentSessionDetails.sessionDetails);
  const isIframePopUp = window.opener && window.opener !== window && window.opener.self !== window.opener.top;
  const parsedUrl = new URL(window.location.href);
  const windowPopupName = window?.name;
  const onDemandAmount = useSelector((state) => state.commonPersisted.onDemandAmount);
  const activePaymentMethod = useSelector((state) => selectActivePaymentMethod(state));
  const upiType = useSelector(state => state.upiStatus.upiType);
  const surchargeDetail = useSelector(state => state.surcharges.surchargeDetail);
  const appliedOfferDetail = useSelector(state => state.offers.appliedOfferDetail);
  const paymentInitiationError = useSelector((state) => state.paymentInitiation.paymentInitiationError);
  const isRetryLimitReached = useSelector((state) => state.paymentInitiation.isRetryLimitReached);
  const retryLimitType = useSelector((state) => state.paymentInitiation.retryLimitType);
  const methodAttemptsLeft = useSelector((state) => state.paymentInitiation.methodAttemptsLeft);
  const paymentMethodDictionary = useSelector((state) => state.paymentSessionDetails.paymentMethodDictionary);
  const paymentSuccessData = useSelector((state) => selectTransactionData(state));
  const failedModal = useSelector((state) => state.paymentInitiation.failedModal);
  const isAutoRefundLoaderActive = useSelector((state) => !!state.autoRefund.activeTransactionId);
  const retryModal = useSelector((state) => state.paymentInitiation.retryModal);
  const activeStatusReason = useSelector((state) => state.finalStatus.activeStatusReason);
  const upiIntentName = useSelector((state) => intentAppName(state));
  const callerType = useSelector((state) => state.paymentSessionDetails.callerType);
  const paymentInitiationData = useSelector((state) => state.paymentInitiation.paymentInitiationData);
  const sessionDetailsLoading = useSelector((state) => state.paymentSessionDetails.sessionDetailsLoading);
  const sessionDetailsLoaded = useSelector((state) => state.paymentSessionDetails.sessionDetailsLoaded);

  const technicalError = useSelector((state) => state.paymentSessionDetails.technicalError);
  const sessionErrorMessage = useSelector((state) => state.paymentSessionDetails.errorMessage);
  const totalPaymentSummaryValue = useSelector((state) => state.additionalComponents.totalPaymentSummaryValue);
  const isLoggedIn = useSelector((state) => state.shopperInfo.isLoggedIn);
  const cardBinData = useSelector((state) => state.binDetails.cardBinData);
  const selectedInstrument = useSelector((state) => state.savedInstrument.selectedIntrument);
  const theme = useSelector((state) => state?.paymentSessionDetails?.sessionDetails?.merchantDetails?.checkoutTheme);
  const primaryColor = theme?.primaryButtonColor || "rgba(24, 144, 255, 1)";


  useEffect(() => {
    const currentUrl = window.location.pathname;
    if (NON_CHECKOUT_PATHS.includes(currentUrl)) return;

    // A different token than the stored one means a new session: drop stale session storage.
    const applyToken = (nextToken) => {
      if (nextToken !== getStorage("session", "tkn")) {
        updateStorage("session", "clear");
      }
      setToken(nextToken);
    };

    const urlToken = new URLSearchParams(window.location.search).get("token");
    if (urlToken) {
      dispatch(setTokenType("checkout-token"));
      applyToken(urlToken);
    } else if (currentUrl === "/finalStatus" || currentUrl === "/paymentFailed") {
      setToken(sessionStorage.getItem("token"));
    } else {
      dispatch(setTokenType("checkout-link"));
      applyToken(currentUrl.substring(currentUrl.lastIndexOf("/") + 1));
    }

    // On browser back/forward the page can be restored from bfcache or history with stale
    // state (e.g. old payment screen or login state after a redirect). Reload to start fresh.
    const handlePageShow = (event) => {
      const navEntry = window.performance?.getEntriesByType?.("navigation")?.[0];
      const isBackForward = navEntry
        ? navEntry.type === "back_forward"
        : window.performance?.navigation?.type === 2;
      // persisted = restored from bfcache; isBackForward = history traversal (legacy
      // performance.navigation.type 2 used as fallback for older browsers).
      if (event.persisted || isBackForward) {
        window.location.reload();
      }
    };
    window.addEventListener("pageshow", handlePageShow);
    return () => window.removeEventListener("pageshow", handlePageShow);
  }, []);

  useEffect(() => {
    syncShopperRefStorage();
    if (!token && token === null) {
      return;
    }
    updateStorage("session", "update", "tkn", token);
    if (token) {
      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const countryName = timeZoneToCountry[timeZone];
      let countryObj = CountryData.find(d => d.name.toLowerCase() === countryName?.toLowerCase());
      const countryCode = countryObj?.code || '';
      const browserTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      dispatch(updateBrowserCountry(countryObj || {}));
      dispatch(paymentSession({ token, browserTimeZone }));
      dispatch(getRetryPolicyRemaining({ token }));
    }
    else {
      dispatch(setIsSessionInvalid(true));
    }
  }, [token]);

  useEffect(() => {
    if (sessionDetails) {
      generateDynamicStyling(sessionDetails);
    }
  }, [sessionDetails]);

  useEffect(() => {
    dispatch(getPaymentInstrumentIssuers());
  }, []);


  useEffect(() => {
    if (!sessionDetailsLoaded) return;

    // Skip on result / completion screens — not a fresh checkout load
    if (PAYMENT_COMPLETION_PATHS.some((p) => window.location.pathname.startsWith(p))) return;

    // How long from page navigation start to session API response
    const navigationStart = window.performance?.timing?.navigationStart || null;
    const sessionFetchDurationMs = navigationStart ? Date.now() - navigationStart : null;

    checkoutLoadedAnalytics("Success", { sessionFetchDurationMs });
  }, [sessionDetailsLoaded])

  useEffect(() => {
    if (technicalError) {
      const formattedErrorMessage =
        typeof sessionErrorMessage === "string"
          ? sessionErrorMessage
          : JSON.stringify(sessionErrorMessage);
      checkoutLoadedWithErrorAnalytics(token, "TechnicalError", formattedErrorMessage);
    }
  }, [technicalError]);

  useEffect(() => {
    if (sessionDetails?.token === "PAID") {
      dispatch(setIsSessionPaid(true));
    } else {
      dispatch(setIsSessionPaid(false));
    }
  }, [sessionDetails]);

  useEffect(() => {
    if (sessionDetails?.status === "PROCESSING") {
      dispatch(setIsSessionPaid(true));
    } else {
      dispatch(setIsSessionPaid(false));
    }
  }, [sessionDetails]);

  useEffect(() => {
    const appliedSurcharges = surchargeDetail?.appliedSurcharges ?? [];
    if (!activePaymentMethod || !appliedSurcharges.length) {
      dispatch(setActiveSurchargeDetail([]));
      dispatch(setTotalSurchargeAmount(null))
    } else {
      // A selected saved card never goes through the BIN lookup, so match on its own brand/classification.
      const isSavedCardSelected = selectedInstrument?.type === "Card";
      const cardInfo = isSavedCardSelected
        ? {
          paymentMethod: {
            brand: selectedInstrument.brand,
            // Saved instruments carry no classification field; the nickname is "<issuer> <Credit|Debit|Prepaid> Card".
            classification:
              selectedInstrument.classification ||
              selectedInstrument.cardNickName?.match(/\b(credit|debit|prepaid)\b/i)?.[1],
          },
        }
        : cardBinData;

      const isCardSurchargeMatched = (surchargeDetails, cardInfo) => {
        if (isEmpty(cardInfo)) return false;

        const hasNetwork = !!surchargeDetails.network;
        const hasClassification = !!surchargeDetails.classification;

        if (!hasNetwork && !hasClassification) return true;

        const sameText = (a, b) => !!a && !!b && String(a).toLowerCase() === String(b).toLowerCase();
        return (
          (!hasNetwork || sameText(surchargeDetails.network, cardInfo?.paymentMethod?.brand)) &&
          (!hasClassification || sameText(surchargeDetails.classification, cardInfo?.paymentMethod?.classification))
        );
      };

      // Instrument-scoped methods: network-less surcharge always applies, network-scoped only once that instrument is selected.
      const isInstrumentSurchargeMatched = (surchargeDetails, applicableOnLower, selectedInstrument) => {
        if (!surchargeDetails.network) return true;
        return (
          selectedInstrument?.type?.toLowerCase() === applicableOnLower &&
          selectedInstrument?.brand === surchargeDetails.network
        );
      };
      const INSTRUMENT_SCOPED_METHODS = new Set(["wallet", "netbanking", "buynowpaylater", "emi"]);

      const matchedSurcharge = appliedSurcharges.filter(({ surchargeDetails }) => {
        const applicableOn = surchargeDetails.applicableOn;
        if (!applicableOn) return true;

        const applicableOnLower = applicableOn.toLowerCase();
        // On the "Recommended" tab the method is the selected instrument's own type (e.g. a saved Card).
        const effectiveMethod = activePaymentMethod === "Recommended" && selectedInstrument?.type ? selectedInstrument.type : activePaymentMethod;
        const methodLower = (effectiveMethod || "").toLowerCase();

        // UPI: match the family (regular/OTM) via activePaymentMethod, then the sub-type (QR/Intent/Collect) via upiType.
        if (applicableOnLower === "upi" || applicableOnLower === "upionetimemandate") {
          const activeUpiFamily = getUpiFamily(activePaymentMethod);
          if (!activeUpiFamily || applicableOnLower !== activeUpiFamily.toLowerCase()) {
            return false;
          }
          if (!surchargeDetails.network) return true;
          return !!upiType && surchargeDetails.network.toLowerCase() === upiType.toLowerCase();
        }

        if (methodLower !== applicableOnLower) return false;

        if (applicableOnLower === "card") {
          return isCardSurchargeMatched(surchargeDetails, cardInfo);
        }
        if (INSTRUMENT_SCOPED_METHODS.has(applicableOnLower)) {
          return isInstrumentSurchargeMatched(surchargeDetails, applicableOnLower, selectedInstrument);
        }
        return true;
      });
      let surchargeTotalFee = 0
      if (matchedSurcharge?.length) {
        matchedSurcharge.forEach(el => surchargeTotalFee += el.calculatedSurchargeFee)
      }
      dispatch(setTotalSurchargeAmount(surchargeTotalFee || null));
      dispatch(setActiveSurchargeDetail(matchedSurcharge));
    }
  }, [activePaymentMethod, upiType, surchargeDetail, cardBinData, selectedInstrument]);

  useEffect(() => {
    if (upiType && !getUpiFamily(activePaymentMethod)) {
      dispatch(setUpiType(""));
    }
  }, [activePaymentMethod, upiType]);

  useEffect(() => {
    if (onDemandAmount) {
      dispatch(handleTotalPaymentSummaryValue(onDemandAmount))
    }
  }, [onDemandAmount])

  useEffect(() => {
    if (!sessionDetailsLoaded) return
    const additionalFieldSets = sessionDetails?.configs?.additionalFieldSets;
    const customFields = sessionDetails?.merchantDetails?.customFields;
    if (additionalFieldSets && sessionDetails?.paymentDetails) {
      // Login / guest / shopper state is owned by ShopperInfoSlice.
      dispatch(syncShopperLogin(sessionDetails));
      dispatch(handleIsShippingAddressDisplay(additionalFieldSets.includes("SHIPPING_ADDRESS")));
      dispatch(handleMerchantLogo(additionalFieldSets.includes("MERCHANT_LOGO")));
      dispatch(handleExpiryTime(additionalFieldSets.includes("TIMER")));
      dispatch(handleOrderItem(additionalFieldSets.includes("ORDER_ITEM_DETAILS")));
      dispatch(handleEmailAddress(additionalFieldSets.includes("SHOPPER_EMAIL")));
      dispatch(handleFullNameField(additionalFieldSets.includes("SHOPPER_NAME")));
      dispatch(handleContactNumberField(additionalFieldSets.includes("SHOPPER_PHONE")));
      dispatch(handleTotalPaymentSummaryField(sessionDetails?.paymentDetails?.onDemandAmount === true));
      dispatch(enableLocalisation(sessionDetails?.merchantDetails?.enableLocalisation || false));
      // Preselect language from session localeCode; otherwise keep current/default (en).
      const localeLanguage = getSessionLocaleLanguage(sessionDetails);
      if (localeLanguage) {
        dispatch(setSelectedLanguage(localeLanguage));
        i18n.changeLanguage(localeLanguage);
      }
    }
    if (customFields && sessionDetails?.paymentDetails) {
      const otherCustomFields = [];
      customFields.forEach((d) => {
        if (d.fieldName === "PAN") dispatch(handlePanField(true));
        else if (d.fieldName === "DATE_OF_BIRTH") dispatch(handleDobField(true));
        else otherCustomFields.push(d);
      });
      dispatch(handleCustomFields(otherCustomFields));
    }

    if (additionalFieldSets && sessionDetails?.paymentDetails && !additionalFieldSets.includes("SHIPPING_ADDRESS")
      && !additionalFieldSets.includes("SHOPPER_EMAIL")
      && !additionalFieldSets.includes("SHOPPER_NAME")
      && !additionalFieldSets.includes("SHOPPER_PHONE")) {
      dispatch(collpaseAddressComponent())
    }
  }, [sessionDetails, document.cookie, sessionDetailsLoaded]);

  useEffect(() => {
    if (!sessionDetailsLoaded) return;
    if (paymentSuccessData?.status === "PAID" || paymentSuccessData?.status === "PROCESSING") return;
    if (sessionDetails?.token) {
      const surchargePayload = {
        "discountedMoney": {
          "amount": appliedOfferDetail?.finalAmount || totalPaymentSummaryValue || sessionDetails?.paymentDetails?.money?.amount,
          "currencyCode": sessionDetails?.paymentDetails?.money?.currencyCode
        }
      }
      dispatch(evaluateSurcharge({ sessionToken: sessionDetails?.token, payload: surchargePayload }));
    }

  }, [sessionDetailsLoaded, sessionDetails, appliedOfferDetail, totalPaymentSummaryValue])

  const templateDictionary = {
    domestic_checkout: {
      navBar: <Navbar />,
      checkout: isMobileLayout ? <MobileLayout /> : <Layouts />,
      success: <PaymentSuccess />,
      failed: <PaymentSuccess isFailed />,
      paymentcompletionhandler: <PaymentCompletionHandler />,
      pspCheckoutHandler: <PspCheckoutHandler />,
      paymentNotify: <PaymentNotify />,
      fppPayment: <FppThreeDSPayment />,
      airwallex: <AirWalllex />,
    },
  };
  const randomParamsForHmh = new URLSearchParams(document.location.search);
  const hmh = randomParamsForHmh.get("hmh");
  const randomParams = new URLSearchParams(document.location.search);
  const pns = randomParams.get("pns");
  useEffect(() => {
    if (pns && !isEmpty(sessionDetails)) {
      if (sessionDetails?.lastTransactionDetails?.retryable) {
        dispatch(showRetryModal(true));
      } else {
        dispatch(showFailedModal(true));
      }
    }
    if (hmh) {
      const url = new URL(window.location.href);
      url.searchParams.set("hmh", hmh);
      window.history.pushState({}, "", url.toString());
    }
  }, [pns, sessionDetails]);

  // Card retry limit: clear the card inputs, the shopper enters another card.
  useEffect(() => {
    if (retryLimitType !== "card") return;
    dispatch(resetCardFormDetails());
    dispatch(resetCardBinData());
  }, [retryLimitType]);

  // Every payment method of the session is out of attempts: same as the session limit.
  useEffect(() => {
    if (retryLimitType !== "method") return;
    const types = Object.keys(paymentMethodDictionary || {}).filter((type) => type !== "Recommended");
    if (types.length && types.every((type) => methodAttemptsLeft[type] === 0)) {
      dispatch(showRetryLimitReached({ reasonCode: "BE_1816" }));
    }
  }, [retryLimitType]);

  const getTemplate = (template) => {
    let layout, success, failed, navBar, paymentcompletionhandler, pspCheckoutHandler, paymentNotify, fppPayment, airwallex;
    if (template in templateDictionary) {
      layout = templateDictionary[template]?.checkout;
      success = templateDictionary[template]?.success;
      failed = templateDictionary[template]?.failed;
      paymentcompletionhandler = templateDictionary[template]?.paymentcompletionhandler;
      pspCheckoutHandler = templateDictionary[template]?.pspCheckoutHandler;
      navBar = templateDictionary[template]?.navBar;
      paymentNotify = templateDictionary[template]?.paymentNotify
      fppPayment = templateDictionary[template]?.fppPayment
      airwallex = templateDictionary[template]?.airwallex
    }
    return (
      <>
        <PaymentProvider>
          {Object.keys(sessionDetails)?.length > 0 && !hmh && navBar}
          <AutoRefundLoader />
          <Routes>
            <Route exact path="/" element={layout} />
            <Route exact path="/fpp/3ds" element={fppPayment} />
            <Route exact path="/airwallex/3ds" element={airwallex} />
            <Route exact path="/:token" element={layout} />
            <Route exact path="/payment-completion-handler" element={paymentcompletionhandler} />
            <Route exact path="/psp-checkout-handler" element={pspCheckoutHandler} />
            <Route exact path="/finalStatus" element={success} />
            <Route exact path="/paymentFailed" element={failed} />
            <Route exact path="/payment-notify" element={paymentNotify} />
          </Routes>
        </PaymentProvider>
      </>
    );
  };


  const handleExitButton = () => {
    if (isIframe) {
      const returnUrlKeyQueryParams = getQueryParams(sessionDetails?.paymentDetails?.frontendReturnUrl)

      const message = {
        action: 'paymentCancelled',
        payload: { status: "failed" }

      };
      if (!isEmpty(returnUrlKeyQueryParams)) {
        message.payload.data = {
          ...message.payload.data,
          ...returnUrlKeyQueryParams
        }
      }

      window.parent.postMessage(message, '*');
    } else {
      const redirectUrl = sessionDetails?.paymentDetails?.frontendBackUrl;
      if (redirectUrl) {
        window.location.href = redirectUrl;
      }
    }
  };


  const handleCloseErrorModal = () => {

    clearPnsFromUrl();
    dispatch(resetTransactionStatus());
    dispatch(resetPaymentInitiation());
    dispatch(showRetryModal(false));
    dispatch(showFailedModal(false));
    dispatch(resetFinalStatusResponse());
    dispatch(resetUpiStatus());
    dispatch(resetErrorMsg());
  }

  // Retry limit modals have a Cancel button (retrying is not possible); on mobile the
  // payment method limit shows as a bottom sheet.
  const isRetryLimitSheet = isMobileLayout && isRetryLimitReached;
  const isCheckoutRetryLimit = retryLimitType === "order" || retryLimitType === "session";
  // Method limit with methods available: Retry switches to the first one, unless the shopper is
  // already on an available method, then it just closes the modal.
  const availableMethods = retryLimitType === "method"
    ? getAvailablePaymentMethods(paymentMethodDictionary, methodAttemptsLeft, isMobileLayout)
    : [];
  const nextAvailableMethod = availableMethods.includes(activePaymentMethod) ? undefined : availableMethods[0];

  // Cancel on the retry limit modal: order / session limits end the checkout on the payment
  // failed page (inside an iframe the SDK owns what happens next), a method limit just closes.
  const handleCancelRetryLimit = () => {
    if (isCheckoutRetryLimit && !isIframe) {
      dispatch(showFailedModal(false));
      navigate("/paymentFailed", { replace: true });
    } else {
      handleCloseErrorModal();
    }
  };

  // Payment method picked in the retry limit modal: close the modal and open that method.
  const handleSelectAvailableMethod = (type) => {
    handleCloseErrorModal();
    if (isMobileLayout) {
      dispatch(removeSelectedIntruments());
      dispatch(changeActivePaymentMethod(type));
    } else {
      dispatch(requestPaymentMethod(type));
    }
  }

  const handleRetryPayment = () => {
    const transactionId = sessionDetails.lastTransactionId
    const token = sessionDetails.token
    dispatch(retryPayment({ token, transactionId }))
  }

  const handleStopAutoRetry = () => {
    stopAutoRetryClickedEvent();
    autoRetryModalClosedEvent();
    handleCloseErrorModal();
  }

  const handleRetryButtonClick = () => {
    retryButtonClickedEvent();
    retryModalClosedEvent();
    handleCloseErrorModal();
  }

  // return getTemplate("domestic_checkout");
  return <>
    {
      !sessionDetailsLoading && (
        <>

          {sessionDetails?.lastTransactionDetails?.retryable && pns && <RetryModal
            icon={<LockOutlined style={{ color: primaryColor, fontSize: "22px" }} />}
            title={t("RETRYING_PAYMENT")}
            desc={t("RETRY_MODAL_HEADING")}
            bottomText={t("RETRY_MODAL_SUBHEADING")}
            showModal={retryModal}
            onCancel={handleStopAutoRetry}
            onRetry={handleRetryPayment}
            primaryBtnText={t("RETRY")}
            secondaryBtnText={t("CANCEL")}
            showSecondaryButton={false}
          />
          }
          <ErrorModal
            icon={
              <InfoCircleOutlined style={{ color: "#FF4D4F", fontSize: "22px" }} />
            }
            title={isRetryLimitReached ? t("RETRY_LIMIT_TITLE") : t("PAYMENT_FAILED")}
            desc={(() => {
              const baseMessage = `${t("PAYMENT_RETRY_NOTICE")}.`;
              let errorMessage = "";
              if (paymentInitiationError) {
                errorMessage = RETRY_LIMIT_KEYS[retryLimitType] ? t(paymentInitiationError) : paymentInitiationError;
              } else if (paymentSuccessData?.status === "FAILED" && paymentSuccessData?.reasonCode?.startsWith("UF")) {
                errorMessage = activeStatusReason;
              } else if (paymentInitiationData?.paymentMethod?.brand === "UpiIntent") {
                return (
                  <div>
                    <TranslateText label={"PAYMENT_FAILED_WITH"}>Payment failed with</TranslateText> {upiIntentName}. <TranslateText label={"RETRY_PAYMENT_WITH"}>Please retry payment with</TranslateText> <TranslateText label={"DIFFERENT_UPI_APP"}>a different UPI app</TranslateText>
                  </div>
                );
              }

              // Retry-limit modal: subtitle becomes the title, plain error text, no "Error Msg:" label.
              if (isRetryLimitReached) {
                return errorMessage ? <div>{errorMessage}</div> : null;
              }

              return (
                <div>
                  {baseMessage}
                  {errorMessage && (
                    <>
                      <br />
                      <br />
                      <b><TranslateText label={"ERROR_MSG"}>Error Msg</TranslateText>: </b>
                      {errorMessage}
                    </>
                  )}
                </div>
              );
            })()}
            asBottomSheet={isRetryLimitSheet}
            onClose={handleCancelRetryLimit}
            primaryOnClick={nextAvailableMethod ? () => handleSelectAvailableMethod(nextAvailableMethod) : isRetryLimitReached && retryLimitType !== "card" && !availableMethods.length ? handleCancelRetryLimit : handleRetryButtonClick}
            showModal={failedModal && !isAutoRefundLoaderActive}
            secondaryOnClick={() => handleExitButton()}
            primaryBtnText={isCheckoutRetryLimit ? t("OK") : retryLimitType === "method" && !availableMethods.length ? t("CANCEL") : t("RETRY")}
            secondaryBtnText={t("CANCEL")}
            showSecondaryButton={false}
          // showSecondaryButton={callerType === "CHECKOUT" && true}
          >
            {retryLimitType === "method" && (
              <AvailablePaymentMethods onSelect={handleSelectAvailableMethod} />
            )}
          </ErrorModal>
        </>
      )
    }




    {(isIframePopUp || windowPopupName) === 'sdk_form_popup' ? <>
      <Loading
        text="Loading"
        subText=""
      />
    </> : getTemplate("domestic_checkout")}
  </>
};

export default BoxPayCheckout;
